import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ErrorResponse } from "@/common/types/errorResponse"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios"

interface UseCardWithSecureInformation {
  onSuccess?: (response?: AxiosResponse<any, any>) => void
  onError?: (error: ErrorResponse) => void
}

export const useCardWithSecureInformation = ({ onSuccess, onError }: UseCardWithSecureInformation) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['cardWithSecureInformation'],
    mutationFn: (id: string) => {
      return privateAxios.get(`/client/cards/${id}/with_secure_information`)
    },
    onSuccess,
    onError,
  })
}
